import { Employee } from '../../features/portal/employees/models/employee';
import { EmployeePermission } from './permissions';
import {
  ROUTE_MAC_APPLICATIONS,
  ROUTE_MAC_TRANSACTIONS,
  ROUTE_MAC_TERMINATIONS,
  ROUTE_MAC_MANUAL_REVIEW,
  ROUTE_PLWC_CREDIT_PLANS,
  ROUTE_PLWC_SUPPLIERS,
  ROUTE_PORTAL_USERS,
  ROUTE_MAC_DISTRIBUTORS,
  ROUTE_OPE_DEALERS,
  ROUTE_PLWC_BUYERS,
} from './routes';

/** Link in the navigation component */
export type NavLink = {
  url: string;
  title: string;
  requiredPermissions: EmployeePermission[];
  children?: NavLink[];
  icon?: string;
  svgIcon?: string;
};

/** Navigation menu links (filter by session permissions in nav component) */
export const NAV_LINKS: NavLink[] = [
  {
    url: 'mac',
    title: 'Mac Program',
    icon: 'local_shipping',
    requiredPermissions: [],
    children: [
      {
        url: ROUTE_MAC_APPLICATIONS,
        title: 'Applications',
        requiredPermissions: [EmployeePermission.APPLICATIONS_ACCESS],
      },
      {
        url: ROUTE_MAC_DISTRIBUTORS,
        title: 'Distributors',
        requiredPermissions: [EmployeePermission.SUPPLIERS_ACCESS],
      },
      {
        url: ROUTE_MAC_TRANSACTIONS,
        title: 'Transactions',
        requiredPermissions: [EmployeePermission.TRANSACTIONS_ACCESS],
      },
      {
        url: ROUTE_MAC_TERMINATIONS,
        title: 'Terminations',
        requiredPermissions: [EmployeePermission.TERMINATION_ACCESS],
      },
      {
        url: ROUTE_MAC_MANUAL_REVIEW,
        title: 'Manual Review',
        requiredPermissions: [EmployeePermission.MYSTIC_ACCESS],
      },
    ],
  },
  {
    url: 'plwc',
    title: 'PLWC Program',
    icon: 'shopping_cart',
    requiredPermissions: [],
    children: [
      {
        url: ROUTE_PLWC_CREDIT_PLANS,
        title: 'Credit Plans',
        requiredPermissions: [EmployeePermission.CREDIT_PLANS_ACCESS],
      },
      {
        url: ROUTE_PLWC_SUPPLIERS,
        title: 'Suppliers',
        requiredPermissions: [EmployeePermission.PLWC_ACCESS],
      },
      {
        url: ROUTE_PLWC_BUYERS,
        title: 'Buyers',
        requiredPermissions: [EmployeePermission.PLWC_ACCESS],
      },
    ],
  },
  {
    url: 'ope',
    title: 'OPE Program',
    icon: 'dashboard',
    requiredPermissions: [EmployeePermission.OPE_ACCESS],
    children: [
      {
        url: ROUTE_OPE_DEALERS,
        title: 'Dealers',
        requiredPermissions: [EmployeePermission.OPE_ACCESS],
      },
    ],
  },
  {
    url: ROUTE_PORTAL_USERS,
    title: 'Users',
    requiredPermissions: [EmployeePermission.USERS_ACCESS],
    icon: 'person',
  },
];
